import React from 'react'

const LeftArrowIcon = () => (
  <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginRight: '8px' }}>
    <path d='M10 2L4 8l6 6' stroke='#000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

const RightArrowIcon = () => (
  <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginLeft: '8px' }}>
    <path d='M6 2l6 6-6 6' stroke='#000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

const Paginator = ({ onPrev, onNext }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        margin: '20px 0'
      }}
    >
      <button
        onClick={onPrev}
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#F1F1F1',
          border: 'none',
          borderRadius: '6px',
          padding: '8px 16px',
          cursor: 'pointer',
          fontFamily: 'Poppins',
          fontSize: '14px'
        }}
      >
        <LeftArrowIcon />
        Wstecz
      </button>

      <div
        style={{
          width: '1px',
          height: '30px',
          backgroundColor: '#E0E0E0'
        }}
      />

      <button
        onClick={onNext}
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#F1F1F1',
          border: 'none',
          borderRadius: '6px',
          padding: '8px 16px',
          cursor: 'pointer',
          fontFamily: 'Poppins',
          fontSize: '14px'
        }}
      >
        Dalej
        <RightArrowIcon />
      </button>
    </div>
  )
}

export default Paginator
